import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-has-weather-alert-icon",
  "use": "icon-has-weather-alert-icon-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-has-weather-alert-icon\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.052 2.193 2.798 12.702c-.222.443.1.965.596.965h10.51a.667.667 0 0 0 .596-.965L9.245 2.192a.667.667 0 0 0-1.193 0Zm-.328 4.804a.926.926 0 1 1 1.847 0L9.365 9.67a.72.72 0 0 1-1.435 0l-.206-2.672Zm.257 4.67a.667.667 0 1 1 1.333 0 .667.667 0 0 1-1.333 0Z\" fill=\"#FE8600\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol